export default __webpack_public_path__ + "static/media/advertisingImg.0ae655ea.png";